import React from "react";
import PropTypes from "prop-types";
import { useTimeRecordsTotalInfo } from "~/repository";
import { decimalToMinutes } from "~/utils/utils.jsx";
import { TimeRecordTotalExpand } from "./TimeRecordTotalExpand.jsx";
import { TimeRecordTotalRealtimeEvents } from "./TimeRecordTotalRealtimeEvents.js";

export const TimeRecordParentTotalContainer = ({
  parentType,
  parentId,
  onChangeExpand,
  showExpandSingle,
  excludeOthers,
  from,
  to,
}) => {
  let query = {};

  if (from && to) {
    query = { ...query, from, to };
  }

  const { data } = useTimeRecordsTotalInfo(parentType, parentId, query);

  return (
    <>
      <TimeRecordTotalRealtimeEvents
        parentType={parentType}
        parentId={parentId}
      />
      {data?.your_time > 0 || (!excludeOthers && data?.other_time > 0) ? (
        <TimeRecordTotalExpand
          loggedUserTotal={decimalToMinutes(data?.your_time)}
          othersUserTotal={!excludeOthers ? decimalToMinutes(data?.other_time) : 0}
          total={
            !excludeOthers ? decimalToMinutes(data?.your_time + data?.other_time) : decimalToMinutes(data?.your_time)
          }
          onChangeExpand={onChangeExpand}
          showExpandSingle={showExpandSingle}
        />
      ) : null}
    </>
  );
};

TimeRecordParentTotalContainer.propTypes = {
  parentType: PropTypes.string.isRequired,
  parentId: PropTypes.number.isRequired,
  onChangeExpand: PropTypes.func,
  showExpandSingle: PropTypes.bool,
  excludeOthers: PropTypes.bool,
  from: PropTypes.string,
  to: PropTypes.string,
};

TimeRecordParentTotalContainer.defaultProps = {
  showExpandSingle: true,
  excludeOthers: false,
};
